import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { DataConfiguration } from '@assess/shared/dynamic-components';
import { Nullable } from '@assess/shared/type-utilities';

import { DynamicValidationSummary } from './dynamic-validation-summary.type';

export type Action = (...args: any) => void;

export type ObservableMembers<T> = {
  [P in keyof T as `${string & P}$`]: Observable<T[P]>;
};

export interface IDynamicContextBindings {
  actionable: Nullable<Record<string, Action>>;
  readable: Nullable<Record<string, any>>;
  editable: Nullable<AbstractControl>;

  // Note that this is not currently "bindable" - i.e. exposed to admins in the JSON
  errors: Nullable<DynamicValidationSummary>;
}

/**
 * Enum representing the IDynamicContext keys
 *
 * Note that if IDynamicContext keys are added or modified above, this should be updated.
 */
export enum DynamicContextBindingsType {
  Actionable = 'actionable',
  Readable = 'readable',
  Editable = 'editable',
}

/**
 * Interface describing the standard shape of a full dynamic context.
 */
export interface IDynamicContext {
  bindings: IDynamicContextBindings & Readonly<ObservableMembers<IDynamicContextBindings>>;
  dataDefinition: Nullable<DataConfiguration>;
  uuid: string;
}
